<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate @input="productAcivateUpdateFlag('extras')">
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">
                            <div class="panel shaded">
                                <h5 class="border-bottom-lightest">Extra services</h5>

                                <div v-if="isLoadingExtras" class="text-center pb-4">
                                    <loader></loader>
                                </div>

                                <div class="text-center dark pb-4" v-else-if="extras.length == 0">
                                    <span>✨ Looks like you have no extras created, please create them <span class="bold underlined pointer" @click="createExtraClick">here</span>.</span>
                                </div>

                                <div v-else>
                                    <table v-if="extras" class="table narrow">
                                        <thead>
                                            <tr>
                                                <th class="text-center ">Name</th>
                                                <th class="text-center ">Price</th>
                                                <th class="text-center ">Quantity</th>
                                                <th class="text-center ">Unlimited</th>
                                                <th class="text-center ">Available on Agents</th>
                                                <th class="text-center ">Available on Widget</th>
                                                <th class="text-center ">Mandatory</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(extra, index) in form.extras" :key="extra.id">
                                                <td class="p-3">
                                                    <v-select
                                                        v-model="extra.item"
                                                        :options="extras"
                                                        label="name"
                                                        @input="selectedExtraChanged($event, extra)"
                                                        placeholder="- Select extra -">
                                                    </v-select>
                                                </td>
                                                <td class="p-3">
                                                    <v-select
                                                        v-model="extra.selectedPrice"
                                                        :options="extra.item.prices"
                                                        label="name"
                                                        @input="selectedPVPChanged($event, index)"
                                                        placeholder="- Select price -">
                                                    </v-select>
                                                </td>
                                                <td class="text-center">
                                                    <input type="number" style="width: 3rem;" v-model.number="extra.quantity" v-if="!extra.capacityUnlimited"/>
                                                    <span v-else class="dark">Unlimited</span>
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.capacityUnlimited" @input="capacityUnlimitedChanged(extra)"></checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isAvailableOnAgents" />
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isAvailableOnWidget" />
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isMandatory"></checkbox>
                                                </td>
                                                <td>
                                                    <i class="ico-delete largest medium" @click="deleteRow(index)"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addRow">
                                        <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Steps from './ProductSteps'
    import Loader from '@/tools/loaders/loader1'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 3,
                isPerson: false,
                form: {
                    extras: [],
                },
                selected: [],
                isLoadingExtras: false,
                originalExtras: []
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.getClonedItem));

            this.addPVPtoName(this.form.extras)
            if(this.form.extras){
                this.originalExtras = JSON.parse(JSON.stringify(this.form.extras))
            }
        },
        // asyncComputed: {
        //     async extraz() {
        //         try {
        //             this.isLoadingExtras = true
        //             let response = await axios.get('/api/inventory/ListExtra', { params: { supplierId: this.account.supplierId }});
        //             this.isLoadingExtras = false
        //
        //             if (response && response.status === 200 && response.data && response.data.length > 0) {
        //
        //
        //                 //adds selectedPrice key to each extra
        //                 response.data.map(extra => {
        //
        //                     //if it has prices (it should by now) tweaks the name wiht the price
        //                     if(extra.prices && extra.prices.length > 0){
        //                         extra.prices.map(price => {
        //                             price.name = price.name + ' - ' + price.grossprice + '€'
        //                             price.helperTweakedName = true
        //                         })
        //                     }
        //                 })
        //
        //                 // Map FK information through selects: for each ID found when editing, map
        //                 // the whole extra object for the dropdown
        //                 if (this.form.extras && this.form.extras.length > 0) {
        //                     this.form.extras.forEach(e => {
        //                         e.item = response.data.find(item => item.id === e.item.id);
        //                     });
        //                 }
        //
        //                 return response.data;
        //             }
        //         }
        //         catch (error) {
        //             this.$toasted.error(error.response.data.message);
        //         }
        //     },
        // },
        computed: {
            ...mapGetters([
                'getClonedItem',
                'account',
                'getExtras',
                'getSelectedItem'
            ]),
            extras: function () {
                if(this.getExtras.length > 0){
                    var output = JSON.parse(JSON.stringify(this.getExtras))
                } else {
                    var output = []
                }

                if(output.length > 0){

                    output.map(extra => {

                        //if it has prices (it should by now) tweaks the name wiht the price
                        if(extra.prices && extra.prices.length > 0){
                            extra.prices.map(price => {
                                price.name = price.name + ' - ' + price.grossprice + '€'
                                price.helperTweakedName = true
                            })
                        }
                    })

                    return output
                } else  {
                    return []
                }
            }
        },
        methods: {
            ...mapActions([
                'initExtras',
                'openModal',
                'clearSelectedExtra'
            ]),
            createExtraClick: function () {
                this.clearSelectedExtra()
                this.openModal('ExtraAdd')
            },
            addRow: function() {
                if (this.form.extras === undefined) {
                    this.$set(this.form, 'extras', []);
                }

                this.form.extras.push(this.createEmptyRow());
                this.$set(this.form.updateFlags, 'extras', true)
            },
            createEmptyRow: function() {
                let extraToDuplicate = JSON.parse(JSON.stringify(this.extras[0]))
                return {
                    id: 0,
                    item: extraToDuplicate,
                    isAvailableOnWidget: false,
                    isAvailableOnAgents: false,
                    isMandatory: false,
                    capacityUnlimited: true,
                    selectedPrice: extraToDuplicate.prices[0]
                };
            },
            selectedExtraChanged: function(event, extra) {
                //this has a fix to prevent setting prince[0] as selected on the first run
                // because this func will run at start [which sucks]
                let selectedPriceId = extra.selectedPrice.id
                let replaceSelectedPrice = true
                extra.item.prices.map(price => {
                    if(selectedPriceId == price.id){
                        replaceSelectedPrice = false
                    }
                })

                if(replaceSelectedPrice){
                    extra.selectedPrice = extra.item.prices[0]
                    this.productAcivateUpdateFlag('extras')
                }


            },
            selectedPVPChanged: function (a, index) {
                // code above ensures that it is only triggered if changed by user and not on page load
                if(!this.originalExtras[index]){
                    // console.log('ALSO CHANGED!');
                    this.productAcivateUpdateFlag('extras')
                    return false
                }
                if(this.form.extras[index] && this.originalExtras[index].selectedPrice.id != a.id){
                    // console.log('CHANGED!');
                    // console.log('was '+this.originalExtras[index].selectedPrice.name +' now is '+ a.name);
                    this.productAcivateUpdateFlag('extras')
                    return false
                }
            },
            capacityUnlimitedChanged: function(extra) {
                if(extra.capacityUnlimited){
                    extra.quantity = null
                } else {
                    extra.quantity = 0
                }
            },
            addPVPtoName: function(extras) {
                if(extras && extras.length > 0){
                    for (let extra of extras) {
                        if(!extra.selectedPrice.helperTweakedName){
                            extra.selectedPrice.name = extra.selectedPrice.name + ' - ' + extra.selectedPrice.grossprice + '€'
                            extra.selectedPrice.helperTweakedName = true
                        }
                    }
                }
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
            deleteRow: function(row) {
                this.productAcivateUpdateFlag('extras')
                this.form.extras.splice(row, 1);
            },
        },
        components: {
            Steps,
            vSelect: extendedVSelect,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// ProductExtras.vue?e4694e6e